// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kNVA","question":"styles_question__2bSF8","description":"styles_description__3adZ3"};